import { useSelector } from 'react-redux'
import React, { useState, useEffect } from 'react';

function Info() {

  const es_en = useSelector((state) => state.translation)
  const [years, setYears] = useState(0);

  useEffect(() => {
    const startDate = new Date('2018-11-05'); // Cambia a tu fecha de inicio
    const today = new Date();

    let diffYears = today.getFullYear() - startDate.getFullYear();

    // Ajustar si el aniversario aún no ha pasado este año
    const hasBirthdayPassed =
      today.getMonth() > startDate.getMonth() ||
      (today.getMonth() === startDate.getMonth() && today.getDate() >= startDate.getDate());

    if (!hasBirthdayPassed) diffYears--;

    setYears(diffYears);
  }, []);

  return (
    <div className="about__info grid" /* style={{justifyContent: 'space-around'}} */>
      <div className="about__box"  /* style={{marginRight: '2rem'}} */>
        <i className="bx bx-award about__icon"></i>
        <h3 className="about__title">{es_en ? "Experience" : "Experiencia"}</h3>
        <h3 className="about__title">{es_en ? `${years} Years Working` : `${years} Años trabajando`}</h3>
      </div>

      <div className="about__box">
        <i className="bx bx-briefcase-alt about__icon"></i>
        <h3 className="about__title">{es_en ? "Completed" : "Completado"}</h3>
        <h3 className="about__title">{es_en ? "6 personal projects" : "6 Proyectos Personales"}</h3>
      </div>


    </div>
  );
}

export default Info